import { createFileRoute } from '@tanstack/react-router';

import { loadConciliationMessages, loadConciliationScreens, suspenseAccountListScreen, suspenseAccountListSearch } from '@/modules/conciliation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Bolsão (router.tsx:1478-1482). A rota estática também impede que o caminho caia no detalhe da conciliação
// (`$conciliationId` = "bolsao").
export const Route = createFileRoute('/_app/gestao-carteira/conciliacao/dataprev/bolsao/')({
  validateSearch: suspenseAccountListSearch,
  staticData: { screen: suspenseAccountListScreen },
  loader: () => loadConciliationMessages(),
  component: lazyScreen(loadConciliationScreens, 'SuspenseAccountListRouteScreen'),
});
